export const iconFontAwesomeHumanitarianFile = (
	<i className="fa-solid fa-file"></i>
);
